(() => {
  'use strict';
  const T = window.ROG_T || {};
  const init = root => {
    if (!root || root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const screen = root.querySelector('[data-film-screen]');
    const video = screen.querySelector('video');
    const enter = root.querySelector('[data-film-enter]');
    const skip = screen.querySelector('[data-film-skip]');
    const pause = screen.querySelector('[data-film-pause]');
    const sound = screen.querySelector('[data-film-sound]');
    const retry = screen.querySelector('[data-film-retry]');
    const status = screen.querySelector('[data-film-status]');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const portrait = matchMedia('(max-width: 749px) and (orientation: portrait)');
    const events = new AbortController();
    const on = (node, name, fn) => node.addEventListener(name, fn, {signal: events.signal});
    let state = 'idle', held = [], scroll = 0, bodyStyle, oldScrollBehavior, timer, wasPlaying = false, destroyed = false, epoch = 0, revealed = false;
    const film = screen.querySelector('.rog-motion__film');
    const toolbar = screen.querySelector('.rog-motion__toolbar');
    const EASE_OUT = 'cubic-bezier(.16,1,.3,1)';
    // Éléments du bienvenu, dans l'ordre de leur sortie.
    const welcomeParts = () => [...root.querySelectorAll('.rog-motion__eyebrow,.rog-motion__line,.rog-motion__description,.rog-motion__enter,.rog-motion__direct')];
    document.body.append(screen);
    // Rog 14/10/2026 (audit SEO) : le film (11 à 13 Mo) et son affiche ne partent plus à l'arrivée.
    // Avant, selectSource() posait video.src dès l'initialisation : le navigateur téléchargeait tout
    // le film alors qu'il ne s'ouvre qu'au clic sur « Bienvenue ». La source est posée au premier clic
    // (le fichier est en « faststart » : la lecture démarre sans attendre la fin du téléchargement).
    let armed = false;
    function selectSource() {
      if (!armed || state !== 'idle') return;
      const url = portrait.matches ? video.dataset.vertical : video.dataset.horizontal;
      if (video.getAttribute('src') === url) return;
      video.src = url;
      video.poster = portrait.matches ? video.dataset.posterVertical : video.dataset.posterHorizontal;
    }
    on(portrait, 'change', selectSource);
    function lock() {
      scroll = window.scrollY;
      bodyStyle = document.body.getAttribute('style');
      oldScrollBehavior = document.documentElement.style.scrollBehavior;
      document.documentElement.style.scrollBehavior = 'auto';
      Object.assign(document.body.style, {position:'fixed', top:`-${scroll}px`, left:'0', right:'0', width:'100%'});
      held = [...document.body.children].filter(node => node !== screen && !['SCRIPT','STYLE','LINK'].includes(node.tagName)).map(node => [node,node.inert]);
      held.forEach(([node]) => { node.inert = true; });
    }
    function unlock(y = scroll) {
      if (!held.length) return;
      held.forEach(([node,inert]) => { node.inert = inert; }); held = [];
      if (bodyStyle === null) document.body.removeAttribute('style'); else document.body.setAttribute('style', bodyStyle);
      window.scrollTo({top:y,behavior:'instant'});
      document.documentElement.style.scrollBehavior = oldScrollBehavior;
    }
    const animate = (node, frames, options) => {
      if (!node?.animate) return Promise.resolve();
      return node.animate(frames, options).finished.catch(() => {});
    };
    // Au lancement : le bienvenu se dissout vers le haut, ligne après ligne, pendant que le blanc monte.
    function leave() {
      if (reduced.matches) return;
      welcomeParts().forEach((node, i) => node.animate?.([{opacity:1,transform:'none',filter:'blur(0)'},{opacity:0,transform:'translate3d(0,-22px,0)',filter:'blur(8px)'}], {duration:560,delay:i*45,easing:'cubic-bezier(.4,0,.2,1)',fill:'forwards'}));
    }
    // Au retour : le bienvenu retrouve son état normal (seules les animations de script sont annulées).
    function restoreWelcome() {
      welcomeParts().forEach(node => node.getAnimations?.().forEach(a => { if (typeof CSSAnimation === 'undefined' || !(a instanceof CSSAnimation)) a.cancel(); }));
    }
    // Le film naît du blanc à sa première image réelle : fondu, léger recul, mise au point.
    function reveal() {
      if (revealed) return;
      revealed = true;
      delete screen.dataset.reveal;
      animate(film, [{opacity:0,transform:'scale(1.035)',filter:'blur(12px)'},{opacity:1,transform:'scale(1)',filter:'blur(0)'}], {duration:reduced.matches?80:950,easing:EASE_OUT,fill:'backwards'});
    }
    function controls() {
      pause.textContent = video.paused ? (T.x_reprendre || 'Reprendre') : (T.x_pause || 'Pause');
      sound.textContent = video.muted ? (T.x_activer_son || 'Activer le son') : (T.x_couper_son || 'Couper le son');
      sound.setAttribute('aria-pressed', String(!video.muted));
    }
    function failed() {
      if (!['loading','playing'].includes(state)) return;
      state = 'error'; screen.dataset.state = state;
      status.textContent = (T.x_video_erreur || 'La vidéo ne peut pas être lue pour le moment.');
      retry.hidden = false; clearTimeout(timer);
    }
    function play() {
      state = 'loading'; screen.dataset.state = state;
      retry.hidden = true; status.textContent = (T.x_film_chargement || 'Chargement du film…');
      clearTimeout(timer); timer = setTimeout(failed, 20000);
      const promise = video.play();
      if (promise) promise.catch(failed);
    }
    on(enter, 'click', () => {
      if (state !== 'idle') return;
      armed = true; epoch++; selectSource(); lock(); revealed = false; screen.dataset.reveal = 'pending'; screen.hidden = false; screen.dataset.state = 'loading';
      video.currentTime = 0; video.muted = false; video.volume = 1;
      controls(); skip.focus({preventScroll:true}); play();
      leave();
      animate(screen, [{opacity:0},{opacity:1}], {duration:reduced.matches?80:520,delay:reduced.matches?0:140,easing:'cubic-bezier(.4,0,.2,1)',fill:'backwards'});
      animate(toolbar, [{opacity:0,transform:'translate3d(0,10px,0)'},{opacity:1,transform:'none'}], {duration:reduced.matches?80:700,delay:reduced.matches?0:1100,easing:EASE_OUT,fill:'backwards'});
    });
    on(video, 'playing', () => {
      if (state === 'exiting' || state === 'idle') {video.pause();return;}
      state = 'playing';screen.dataset.state = state;status.textContent = '';retry.hidden = true;clearTimeout(timer);controls();reveal();
    });
    on(video, 'pause', controls);
    on(video, 'error', failed);
    on(video, 'waiting', () => {if(state === 'playing'){status.textContent=(T.x_film_chargement || 'Chargement du film…');clearTimeout(timer);timer=setTimeout(failed,20000);}});
    on(retry, 'click', () => {if(state === 'error'){video.load();play();}});
    on(pause, 'click', () => {if(state === 'playing'){if(video.paused)play();else video.pause();}});
    on(sound, 'click', () => {video.muted=!video.muted;controls();});
    async function finish() {
      if (state === 'idle' || state === 'exiting') return;
      const ticket = epoch;
      state = 'exiting';screen.dataset.state = state;clearTimeout(timer);video.pause();
      // Opaque white stays in place while the document moves. Only transforms and opacity animate.
      await animate(screen.querySelector('.rog-motion__film'), [{opacity:1,transform:'scale(1)'},{opacity:0,transform:'scale(.985)'}], {duration:reduced.matches?80:420,easing:'cubic-bezier(.22,1,.36,1)',fill:'forwards'});
      if(destroyed || ticket !== epoch) return;
      const target = document.getElementById('rogx-selecteur');
      unlock();
      const header = document.querySelector('.rogx-header, sticky-header, header');
      const offset = Math.min(110, header?.getBoundingClientRect().height || 76);
      if(target) window.scrollTo({top:window.scrollY+target.getBoundingClientRect().top-offset,behavior:'instant'});
      const heading = target?.querySelector('h2');
      const fade = animate(screen,[{opacity:1},{opacity:0}],{duration:reduced.matches?100:620,easing:'cubic-bezier(.22,1,.36,1)',fill:'forwards'});
      if(target && !reduced.matches) animate(target.querySelector('.vehicle-heading'),[{opacity:0,transform:'translateY(24px)'},{opacity:1,transform:'translateY(0)'}],{duration:700,delay:80,easing:'cubic-bezier(.22,1,.36,1)'});
      await fade;
      if(destroyed || ticket !== epoch) return;
      screen.hidden = true;screen.getAnimations({subtree:true}).forEach(a=>a.cancel());state='idle';revealed=false;delete screen.dataset.reveal;restoreWelcome();
      if(heading){heading.tabIndex=-1;heading.focus({preventScroll:true});}else enter.focus({preventScroll:true});
    }
    on(skip,'click',finish);on(video,'ended',finish);
    on(screen,'keydown',event=>{
      if(event.key==='Escape'){event.preventDefault();finish();}
      if(event.key==='Tab'){
        const buttons=[...screen.querySelectorAll('button')].filter(b=>!b.hidden&&!b.disabled);
        if(event.shiftKey&&document.activeElement===buttons[0]){event.preventDefault();buttons.at(-1).focus();}
        else if(!event.shiftKey&&document.activeElement===buttons.at(-1)){event.preventDefault();buttons[0].focus();}
      }
    });
    on(document,'visibilitychange',()=>{
      if(document.hidden){wasPlaying=state==='playing'&&!video.paused;video.pause();}
      else if(wasPlaying&&state==='playing'){wasPlaying=false;play();}
    });
    on(window,'pagehide',()=>{epoch++;video.pause();clearTimeout(timer);unlock();screen.hidden=true;screen.getAnimations({subtree:true}).forEach(a=>a.cancel());state='idle';revealed=false;delete screen.dataset.reveal;restoreWelcome();});
    on(document,'shopify:section:unload',e=>{if(!e.target.contains(root))return;destroyed=true;video.pause();clearTimeout(timer);unlock();events.abort();screen.remove();});
  };
  document.querySelectorAll('[data-rog-motion]').forEach(init);
  const selector = document.getElementById('rogx-selecteur');
  if(selector){
    const titleObserver = new MutationObserver(()=>{const h=selector.querySelector('h2');if(h && h.textContent !== (T.x_sel_titre || 'Votre véhicule.')) h.textContent=(T.x_sel_titre || 'Votre véhicule.');});
    titleObserver.observe(selector,{childList:true,subtree:true});
    const h=selector.querySelector('h2');if(h)h.textContent=(T.x_sel_titre || 'Votre véhicule.');
  }
  document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-rog-motion]').forEach(init));
})();
